
<template>
  <div class="user-comment">
    <!-- //信息采集记录 -->
    <el-row class="t-header">
      <el-col :span="4">评论内容</el-col>
      <el-col :span="3">评论时间</el-col>
      <el-col :span="5">资源名称</el-col>
      <el-col :span="2">类型</el-col>
      <el-col :span="3">回复</el-col>
      <el-col :span="3">回复时间</el-col>
      <el-col :span="2">状态</el-col>
      <el-col :span="2">操作</el-col>
    </el-row>
    <el-row class="content" v-if="resultData.list&&resultData.list.length>0" v-loading="tableLoading">
      <el-row class="content-item" v-for="(item,index) in resultData.list" :key="index">
        <el-row class="info">
          <el-col :span="4">{{item.comment_content}}</el-col>
          <el-col :span="3">{{item.created_at}}</el-col>
          <el-col :span="5">{{item.course_name}}</el-col>
          <el-col :span="2">
            <span v-show="item.course_mode==1">语音直播</span>
            <span v-show="item.course_mode==2">语音录播</span>
            <span v-show="item.course_mode==3">视频直播</span>
            <span v-show="item.course_mode==4">视频录播</span>
          </el-col>
          <el-col :span="3">{{item.user_nick_name}}</el-col>
          <el-col :span="3">{{item.updated_at}}</el-col>
          <el-col :span="2">
            <span v-show="item.state==2">精选</span>
            <span v-show="item.state==1">显示</span>
            <span v-show="item.state==-1">隐藏</span>
            <span v-show="item.state==-2">黑名单</span>
          </el-col>
          <el-col :span="2" class="blue cp">
            <span @click="respondMessage(item,'1')">回复</span>
          </el-col>
        </el-row>
      </el-row>
    </el-row>

    <div class="tc mt40">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="Number(search.page)"
        :page-size="Number(search.size)"
        layout="total, prev, pager, next"
        :total="Number(resultData.count)"
      ></el-pagination>
    </div>

    <!-- //回复评论和消息推送的弹窗 -->
    <RespondMessage
      :respondVisible.sync="respondVisible"
      :resmessage="resmessage"
      :titleType="titleType"
    ></RespondMessage>
  </div>
</template>

<script>
//引入回复评论和回复内容
import RespondMessage from "../components/respond-message";

import { _commentList } from "@/api/user.js";

//引入混合mixins模式
import user_mixins from "../components/user-mixins";

export default {
  created() {
    this.initCommentsList();
  },
  props: {
    user_id: {
      type: String
    }
  },
  mixins: [user_mixins],
  components: {
    RespondMessage
  },
  data() {
    return {
      search: {
        page: 1,
        size: 10
      },
      tableLoading: false,
      resultData: {}
    };
  },
  methods: {
    //查询信息
    seachList() {
      console.log("搜索课程");
    },

    //翻页
    handleCurrentChange(val) {
      this.search.page = val;
      this.initCommentsList();
    },
    reply(item) {
      this.privateDialogVisible = true;
    },
    //加载列表
    initCommentsList() {
      this.tableLoading = true;
      _commentList({
        params: {
          page: this.search.page,
          size: this.search.size,
          user_id: 0
        }
      }).then(res => {
        this.tableLoading = false;
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.user-comment {
  .t-header {
    margin-top: 20px;
    background-color: @table-bg;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    font-weight: bold;
  }
  .content {
    .content-item {
      .info {
        height: 60px;
        line-height: 60px;  
        padding: 0 10px;
        font-weight: 500;
        overflow: hidden;
      }
      &:nth-child(2n) {
        background-color: #fefefe;
      }
      &:hover {
        background-color: @table-bg;
      }
    }
  }
}
</style>